import "../styles/legal.css"
import { useNavigate } from "react-router-dom"

export default function PrivacyPage() {
    const nav = useNavigate()
    return (
        <div className="legal-page">
            <nav className="legal-nav">
                <span className="legal-logo" onClick={() => nav("/")}>ArbSignal</span>
            </nav>

            <div className="legal-content">
                <h1>Privacy Policy</h1>
                <p className="legal-updated">Last updated: April 2026</p>

                <h2>What we collect</h2>
                <p>We collect only what's necessary to operate the service:</p>
                <ul>
                    <li><strong>Email address</strong> — for login and notifications</li>
                    <li><strong>Password</strong> — stored as a bcrypt hash, never plaintext</li>
                    <li><strong>Telegram chat ID</strong> — only if you connect Telegram alerts</li>
                    <li><strong>Subscription preferences</strong> — exchanges selected, alert thresholds, fee overrides</li>
                    <li><strong>Payment data</strong> — handled entirely by Dodo Payments. We never see card numbers.</li>
                    <li><strong>Usage logs</strong> — IP address, login timestamps, basic analytics</li>
                </ul>

                <h2>What we do NOT collect</h2>
                <ul>
                    <li>We do not connect to your exchange accounts</li>
                    <li>We do not access your trading history</li>
                    <li>We do not collect or process your funds — we are a signal service only</li>
                    <li>We do not sell your data to third parties</li>
                </ul>

                <h2>How we use your data</h2>
                <ul>
                    <li>To deliver the service and send alerts you requested</li>
                    <li>To process payments via Dodo Payments</li>
                    <li>To send transactional emails (verification, payment receipts, expiration warnings)</li>
                    <li>To improve the product based on aggregated, anonymized usage</li>
                </ul>

                <h2>Third-party services we use</h2>
                <ul>
                    <li><strong>Dodo Payments</strong> — payment processing (Merchant of Record)</li>
                    <li><strong>Resend</strong> — transactional email delivery</li>
                    <li><strong>Telegram</strong> — alert delivery (only if you connect)</li>
                    <li><strong>Google OAuth</strong> — sign-in (only if you choose Google login)</li>
                    <li><strong>Hetzner</strong> — server hosting (Germany, GDPR-compliant)</li>
                </ul>

                <h2>Data retention</h2>
                <ul>
                    <li>Active accounts: data kept indefinitely</li>
                    <li>Canceled accounts: data kept 90 days, then deleted</li>
                    <li>Payment records: kept 7 years for tax compliance</li>
                </ul>

                <h2>Your rights (GDPR)</h2>
                <p>If you are in the EU/UK/EEA, you have the right to:</p>
                <ul>
                    <li>Request a copy of your data</li>
                    <li>Correct inaccurate data</li>
                    <li>Delete your account and associated data</li>
                    <li>Object to processing</li>
                    <li>Receive your data in a portable format</li>
                </ul>
                <p>To exercise these rights, email <a href="mailto:privacy@arb-signal.com">privacy@arb-signal.com</a>.</p>

                <h2>Cookies</h2>
                <p>We use only essential cookies (login session). No tracking, advertising, or analytics cookies.</p>

                <h2>Security</h2>
                <p>We use HTTPS everywhere, bcrypt password hashing, JWT authentication with short expiry,
                    and a hardened Linux server. We do not store payment card data — that's exclusively
                    handled by Dodo Payments.</p>

                <h2>Changes to this policy</h2>
                <p>We may update this policy occasionally. Material changes will be communicated via email.</p>

                <h2>Contact</h2>
                <p>Questions? Email <a href="mailto:privacy@arb-signal.com">privacy@arb-signal.com</a></p>
            </div>
        </div>
    )
}
